module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/xRaFMZq3IcMye6OG0QWmK-8dc9e731f7adda6ba5ab2fc3f6dabf37.jpg";